'use client';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import Button from '../Button';
import Modal from '../Modal';

import VillagesHeaderFilter, { VillagesHeaderDicts } from './Filter';
import { removeBodyScrollbar } from '@/utils/helpers';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './schema';

type Props = {
  dicts: VillagesHeaderDicts;
  lang: string;
  modalIsOpen: boolean;
  setModalIsOpen: Dispatch<SetStateAction<boolean>>;
  form: UseFormReturn<FormValues, any, undefined>;
};

export default function MobileVillagesHeader({
  dicts,
  lang,
  modalIsOpen,
  setModalIsOpen,
  form,
}: Props) {
  const [headerTop, setHeaderTop] = useState<number | undefined>(undefined);

  useEffect(() => {
    const headerElement = document
      .querySelector('#mobile-header')
      ?.getBoundingClientRect();
    setHeaderTop(headerElement?.top);
  }, []);

  useEffect(() => {
    if (!headerTop) return;

    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  }, [headerTop]);

  useEffect(() => {
    removeBodyScrollbar(modalIsOpen);
  }, [modalIsOpen]);

  const isSticky = (e: Event) => {
    const headerElement = document.querySelector('#mobile-header');
    const scrollTop = window.scrollY;
    if (headerTop && scrollTop >= headerTop) {
      headerElement?.classList.add('is-sticky');
    } else {
      headerElement?.classList.remove('is-sticky');
    }
  };

  return (
    <>
      <div
        id="mobile-header"
        className="desktop:hidden flex flex-col justify-center items-center py-4 [&.is-sticky]:fixed [&.is-sticky]:top-0 [&.is-sticky]:left-0 [&.is-sticky]:w-full [&.is-sticky]:bg-white [&.is-sticky]:px-4 [&.is-sticky]:h-[100px] [&.is-sticky]:md:px-[2.5rem] [&.is-sticky]:z-[999] [&.is-sticky]:transition-shadow [&.is-sticky]:ease-linear [&.is-sticky]:duration-200 [&.is-sticky]:shadow-[0_5px_8px_-6px_grey]">
        <Button
          onClick={() => setModalIsOpen(true)}
          className="text-xs h-[44px] desktop:hidden">
          {dicts.contentDict.findYourVilla}
        </Button>
      </div>
      <Modal.Root open={modalIsOpen} onOpenChange={setModalIsOpen}>
        <Modal.Content
          contentCustomClass="md:mt-[-10vh] md:mb-[50px]"
          onOpenChange={setModalIsOpen}>
          <VillagesHeaderFilter form={form} lang={lang} dicts={dicts} />
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
